import { permissionsByEntity, useAuth, useCheckPermissions } from '@cmg/auth';
import type { UUID } from '@cmg/common';
import { useMemo } from 'react';

export type Props = {
  userOfferings: { userId?: UUID | null; isShared: boolean }[];
};

export const useCheckIsFollowingOffering = ({ userOfferings }: Props) => {
  const { oidcUserId } = useAuth();
  const canCanSeeSharedFollowedOfferings = useCheckPermissions([
    permissionsByEntity.SharedFollowedOfferings.READ,
  ]);

  return useMemo(() => {
    if (canCanSeeSharedFollowedOfferings) {
      return userOfferings.some(offering => offering.isShared);
    }

    return userOfferings.some(offering => offering.userId === oidcUserId);
  }, [canCanSeeSharedFollowedOfferings, oidcUserId, userOfferings]);
};
